import ApiService from './api.service'

const ExportService = {
  gamesPlayedExport (uuid, data) {
    return ApiService.postBlob('api/super-admin/clients/' + uuid + '/export-games-csv', data)
  }
}

export default ExportService
